import { Component, HostListener } from '@angular/core';
import { CurrentRouteService } from '../services/current-route.service';

@Component({
  selector: 'app-header-top-box',
  templateUrl: './header-top-box.component.html',
  styleUrls: ['./header-top-box.component.scss'],
  standalone: false
})
export class HeaderTopBoxComponent {
  userScrolledFromTop: boolean = false;
  routeClassNames: any = {
    '/core-hr-product-page': 'coreHrTopBgSec',
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.userScrolledFromTop = window.scrollY > 20;
  }

  constructor(private currentRouteService: CurrentRouteService) { }
  topText: string = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
  topLink: string = 'Try infithra Today!';
  topLinkExternal: string = '';
  class: boolean = false;

  getRouteClass() {
    const route = this.currentRouteService.getRoute();

    // Reset all values on every route change
    this.topLinkExternal = '';
    this.topText = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
    this.topLink = 'Try infithra Today!';

    switch (route) {
      case '/people-analytics':
        this.topText = 'Disconnected systems holding you back? Automate HR reports on a single platform.';
        this.topLink = 'Schedule a demo!';
        break;

      case '/contact-us':
        this.topText = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
        this.topLink = 'Try infithra Today!';
        break;

      case '/leave-management':
        this.topText = 'Leave requests piling up? Automate approvals & tracking with a smart ESS.';
        this.topLink = 'Get a free demo!';
        break;

      case '/demo':
        this.topText = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
        this.topLink = 'See infithra in action!';
        break;

      case '/product-demo':
        this.topText = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
        this.topLink = 'Try infithra Today!';
        break;

      case '/client-stories-page':
        this.topText = 'Optimize Your People and Payroll Operations with Cloud-Based HR.';
        this.topLink = 'Try infithra Today!';
        break;

      case '/integrations':
        this.topText = 'Disconnected systems slowing you down? Streamline HR & payroll in one place.';
        this.topLink = 'Get a free demo!';
        break;

      case '/attendance-management':
        this.topText = 'Struggling with attendance? Track it effortlessly across locations with infithra\'s ESS.';
        this.topLink = 'Try infithra Today!';
        break;

      case '/pricing':
        this.topText = 'Find the perfect plan with no hidden fees. Customize infithra to fit your needs—';
        this.topLink = 'get a demo!';
        break;

      case '/core-hr':
        this.topText = 'Manage your entire organization through a single system. HR made simple - ';
        this.topLink = 'Try infithra today!';
        break;

      case '/employee-management':
        this.topText = 'Manage your entire workforce through a single system. HR made simple - ';
        this.topLink = 'Try infithra today!';
        break;

      case '/use-cases':
        this.topText = 'Simplify people and payroll management with cloud-based HR. ';
        this.topLink = 'Try infithra today!';
        break;

      case '/':
        this.topText = 'The technology behind infithra now operates as ';
        this.topLinkExternal = 'https://vantheon.com';
        break;

      case '/about-us':
        this.topText = 'Simplify people and payroll management with cloud-based HR. ';
        this.topLink = 'Try infithra today!';
        break;

      case '/blog':
        this.topText = 'Simplify people and payroll management with cloud-based HR. ';
        this.topLink = 'Try infithra today!';
        break;

      default:
        return '';
    }

    return this.routeClassNames[route];
  }

  getRouteLink(): string {
    const route = this.currentRouteService.getRoute();
    return route === '/demo' ? '/product-tour' : '/demo';
  }
}